import routes from "../consts/routes.json";
import {
    AENDERUNGSANTRAG_ANLAGE,
    ANLAGE,
    BERICHT,
    BESCHEID,
    BETRIEB,
    BETRIEB_STAMMDATEN_AENDERUNG,
    ENTLASTUNG, JAHRESBERICHT, JAHRESBERICHT_PARAMETER_MESSWERTE,
    MESSSTELLE,
} from "../consts/fachobjekt";
import Box from "@material-ui/core/Box";
import React from "react";
import {calculateBescheidLink} from "../initialObjects/BescheidObjects";
import {getBescheidEndpoint} from "../services/BescheidsService";
import http, {handleApiException, isApiCancel} from "../services/HttpService";
import {getAnlageEndpoint, getJahresberichtByIDEndpoint} from "../services/AnlagenService";
import {calculateAnlagenLink, calculateEntlastungsAnlagenLink} from "../initialObjects/AnlageObjects";
import {toast} from "react-toastify";
import {getMessstelleEndpoint} from "../services/Messstellenservice";
import {calculateFirstLevelEntlastungsanlageMessstelleLink, calculateMessstelleLink} from "../initialObjects/MessstellenObjects";
import {calculateJahresberichtLink} from "../components/betriebsakte/jahresbericht/JahresberichtObjects";

const newString = "neu";

export function getCreateAnlageInBetrieb(betriebsId, typ, art) {
    const route = `${routes.BETRIEBSAKTE_RAW}/${betriebsId}/${newString}${routes.BETRIEBSAKTE_ANLAGENDATEN}?typ=${typ}`;
    return art ? route + "&art=" + art : route;
}

/**
 * Funktion, welche einen String mit einem enthaltenen Link der Form "Direkt zum Fachobjekt: {Name des Fachobjekts}"
 * @returns {JSX.Element|string}
 */
export function createDirectLink(fachobjektbezug, bezugZuFachobjekt, fachobjektId, onClick, history) {
    switch (fachobjektbezug) {
        case ANLAGE:
        case AENDERUNGSANTRAG_ANLAGE:
            return createLink("zur Anlage", fachobjektbezug, bezugZuFachobjekt, fachobjektId, onClick, history);
        case BETRIEB:
        case BETRIEB_STAMMDATEN_AENDERUNG:
            return createLink("zum Betrieb", fachobjektbezug, bezugZuFachobjekt, fachobjektId, onClick, history);
        case BESCHEID:
            return createLink("zum Bescheid", fachobjektbezug, bezugZuFachobjekt, fachobjektId, onClick, history);
        case BERICHT:
            return createLink("zum Bericht", fachobjektbezug, bezugZuFachobjekt, fachobjektId, onClick, history);
        case MESSSTELLE:
            return createLink("zur Messstelle", fachobjektbezug, bezugZuFachobjekt, fachobjektId, onClick, history);
        case JAHRESBERICHT:
            return createLink("zum Jahresbericht", fachobjektbezug, bezugZuFachobjekt, fachobjektId, onClick, history);
        default:
            return "";
    }
}

export function createCustomTextLink(text, fachobjektbezug, fachobjektId, history) {
    return (
        <Box mb={1}>
            <Box
                component="span"
                color="#0288d1"
                onClick={() => handleDirectLinkActivation(fachobjektbezug, fachobjektId, history, false)}
            >
                <u>{text}</u>
            </Box>
        </Box>
    );
}

function createLink(targetString, fachobjektbezug, bezugZuFachobjekt, fachobjektId, onClick, history, readOnly = false) {
    return (
        <Box mb={1}>
            Direkt {targetString}:{" "}
            <Box
                component="span"
                color="#0288d1"
                onClick={() => {
                    onClick();
                    handleDirectLinkActivation(fachobjektbezug, fachobjektId, history, readOnly);
                }}
            >
                <u>{bezugZuFachobjekt}</u>
            </Box>
        </Box>
    );
}

export async function handleDirectLinkActivation(fachobjektbezug, fachobjektId, history, readOnly, hasFirstLevelEntlastungsanlagen = false) {
    const modus = readOnly ? "modus=l" : "modus=s";
    const currentURL = history.location.pathname;
    switch (fachobjektbezug) {
        case ANLAGE:
            http.get(getAnlageEndpoint(fachobjektId))
                .then(({data}) => history.push(calculateAnlagenLink(data, modus)))
                .catch((e) => handleApiException(e, "Fehler beim Aufruf der Anlage"));
            break;
        case AENDERUNGSANTRAG_ANLAGE:
            http.get(getAnlageEndpoint(fachobjektId))
                .then(({data}) => history.push(calculateAnlagenLink(data, modus) + "&stammdatenAntrag=true"))
                .catch((e) => {
                    if (!isApiCancel(e)) {
                        handleApiException(e, "Fehler beim Aufruf der Anlage");
                    } else {
                        toast.error("Fehler beim Aufruf der Anlage");
                    }
                });
            break;
        case BETRIEB:
            history.push(routes.BETRIEBSAKTE_RAW + "/" + fachobjektId + "?" + modus);
            break;
        case BETRIEB_STAMMDATEN_AENDERUNG:
            history.push(routes.BETRIEBSAKTE_RAW + "/" + fachobjektId + "?" + modus + "&stammdatenAntrag=true");
            break;
        case BESCHEID:
            http.get(getBescheidEndpoint(fachobjektId))
                .then(({data}) => {
                    history.push(calculateBescheidLink(data, modus));
                })
                .catch((e) => handleApiException(e, "Fehler beim Aufruf der Anlage"));
            break;
        case BERICHT:
            http.get(getJahresberichtByIDEndpoint(fachobjektId))
                .then(({data}) => {
                    history.push(calculateJahresberichtLink(data, modus));
                })
                .catch((e) => handleApiException(e, "Fehler beim Aufruf des Jahresberichts"));
            break;
        case MESSSTELLE:
            http.get(getMessstelleEndpoint(fachobjektId))
                .then(({data}) => {
                    // Es gibt einige Sonderfälle, bei denen Entlastungsanlagen auf der ersten
                    // Ebene der Navigation sind (z.B. bei Betrieben vom Typ "KANAL_KOMMUNAL").
                    // In diesem Fall muss ein angepasster Link zu Messstellen generiert werden.
                    const link = hasFirstLevelEntlastungsanlagen ?
                        calculateFirstLevelEntlastungsanlageMessstelleLink(data) : calculateMessstelleLink(data);
                    history.push(link);
                })
                .catch((e) => {
                    if (!isApiCancel(e)) {
                        handleApiException(e, "Fehler beim Aufruf der Messstelle");
                    } else {
                        toast.error("Fehler beim Aufruf der Messstelle");
                    }
                });
            break;
        case ENTLASTUNG:
            http.get(getAnlageEndpoint(fachobjektId))
                .then(({data}) => history.push(calculateEntlastungsAnlagenLink(data, modus)))
                .catch((e) => handleApiException(e, "Fehler beim Aufruf der Anlage"));
            break;
        case JAHRESBERICHT:
            history.push(currentURL.replace(/\/uebersicht\/.*/, "/" + fachobjektId + "/jahresberichtdaten"));
            break;
        case JAHRESBERICHT_PARAMETER_MESSWERTE:
            history.push(currentURL.concat("/parameter/" + fachobjektId));
            break;
        default:
            return "";
    }
}
